export enum MenuItemDisplayType {
  Text = 'TEXT',
  Icon = 'ICON',
  IconText = 'ICON_TEXT',
  Button = 'BUTTON',
}

// this list comes from Admin UI. And defines list of all possible internal pages.
// https://github.com/Accedo-Products/one-admin/blob/cb3e76f72fe8d856b8779c4d252641a7f2117a5b/src/common/utils/page/page.constants.ts#L10C13-L10C25
export enum InternalPageId {
  Search = 'SEARCH',
  Favorites = 'FAVORITES',
  WatchHistory = 'WATCH_HISTORY',
  Login = 'LOGIN',
  Register = 'REGISTER',
  Iap = 'IAP',
  ProgramList = 'PROGRAM_LIST',
  TermsAndConditions = 'TERMS_AND_CONDITIONS',
  Settings = 'SETTINGS',
  More = 'MORE',
  ForgotPassword = 'FORGOT_PASSWORD',
  SubscriptionCancel = 'SUBSCRIPTION_CANCEL_PAGE',
}

export enum MenuType {
  TOP = 'top-menu',
  HAMBURGER = 'hamburger',
}
